buyBonusPopup = {};

buyBonusPopup.infoText = undefined;

buyBonusPopup.init = function () {
  buyBonusPopup._callback = undefined;

  buyBonusPopup.chosenChest = undefined;

  buyBonusPopup.chosenChestTarget = {
    landscape: 260,
    portrait: 540,
  };

  buyBonusPopup.raiseChestAnim = undefined;

  buyBonusPopup.buyBonusButton = resourceManager.get("buttonContainer:buttonBar:buyBonusButton");

  buyBonusPopup.continueBox = resourceManager.get("buyABonusContainer:buyBonusPopup:continueBox");
  buyBonusPopup.continueBox.visible = false;

  buyBonusPopup.background = resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground");

  buyBonusPopup.closeButton = resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:closeButton");

  buyBonusPopup.closeButton.onPressedCallback = buyBonusPopup.onClickedNo;

  buyBonusPopup.stakePreviousButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:stakePrevious"
  );

  buyBonusPopup.stakePreviousButton.onPressedCallback = buyBonusPopup.onStakePreviousPressed;

  buyBonusPopup.stakeNextButton = resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:stakeNext");

  buyBonusPopup.stakeNextButton.onPressedCallback = buyBonusPopup.onStakeNextPressed;

  buyBonusPopup.baseStakeText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:baseStakeText"
  );

  buyBonusPopup.lowerFreeSpinsCostText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel1AssetsContainer:totalWinPanel1Text"
  );

  buyBonusPopup.middleFreeSpinsCostText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel2AssetsContainer:totalWinPanel2Text"
  );

  buyBonusPopup.higherFreeSpinsCostText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel3AssetsContainer:totalWinPanel3Text"
  );

  buyBonusPopup.chestAnimationContainer = resourceManager.get("chestAnimationContainer");

  //buy buttons
  buyBonusPopup.lowerFreeSpinsButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:buyButton1"
  );
  buyBonusPopup.middleFreeSpinsButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:buyButton2"
  );
  buyBonusPopup.higherFreeSpinsButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:buyButton3"
  );
  buyBonusPopup.baseStakeText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:baseStakeText"
  );

  buyBonusPopup.textLow = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel1AssetsContainer:chestPanel1Text"
  );
  buyBonusPopup.textLow.setText("6-12 " + buyBonusPopup.textLow.text);

  buyBonusPopup.textMid = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel2AssetsContainer:chestPanel2Text"
  );
  buyBonusPopup.textMid.setText("6-24 " + buyBonusPopup.textMid.text);

  buyBonusPopup.textHigh = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel3AssetsContainer:chestPanel3Text"
  );
  buyBonusPopup.textHigh.setText("12-24 " + buyBonusPopup.textHigh.text);

  buyBonusPopup.low = {
    button: buyBonusPopup.lowerFreeSpinsButton,
    text: resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:buyButton1:buyButton1BuyText"),
    container: resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel1AssetsContainer"),
  };
  buyBonusPopup.mid = {
    button: buyBonusPopup.middleFreeSpinsButton,
    text: resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:buyButton2:buyButton2BuyText"),
    container: resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel2AssetsContainer"),
  };
  buyBonusPopup.high = {
    button: buyBonusPopup.higherFreeSpinsButton,
    text: resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:buyButton3:buyButton3BuyText"),
    container: resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel3AssetsContainer"),
  };
  buyBonusPopup.bubblesBack = resourceManager.get("risingBubblesBack");
  buyBonusPopup.bubblesFront = resourceManager.get("risingBubblesFront");
  buyBonusPopup.bubblesBack.setup();
  buyBonusPopup.bubblesFront.setup("bubbles_emitter_front");

  buyBonusPopup.animationChestGsap = undefined;

  buyBonusPopup.lowerFreeSpinsButton.onPressedCallback = buyBonusPopup.onClickedYesLower;
  buyBonusPopup.middleFreeSpinsButton.onPressedCallback = buyBonusPopup.onClickedYesMed;
  buyBonusPopup.higherFreeSpinsButton.onPressedCallback = buyBonusPopup.onClickedYesHigh;

  buyBonusPopup.chestAnimations = {
    silver: resourceManager.createObject("movie", "rightChestSilver", "chestAnimationContainer", {
      definition: "silverChest",
      anchor: 0.5,
      scaleX: 1,
      scaleY: 1,
      loop: false,
    }),
    mystery: resourceManager.createObject("movie", "mysteryChest", "chestAnimationContainer", {
      definition: "silverChest",
      anchor: 0.5,
      scaleX: 1,
      scaleY: 1,
      loop: false,
    }),
    gold: resourceManager.createObject("movie", "rightChestGold", "chestAnimationContainer", {
      definition: "goldChest",
      anchor: 0.5,
      scaleX: 1,
      scaleY: 1,
      loop: false,
    }),
  };
  resourceManager.createObject("sprite", "questionMark", "chestAnimationContainer:mysteryChest", {
    anchor: 0.5,
    scale: 2,
    y: 160,
    fileName: "BuyBonus/BB_Mystery.png",
  });
  buyBonusPopup.burst = resourceManager.createObject("sprite", "buyBonusBurst", "chestAnimationContainer", {
    fileName: "Chests/Chest_Burst.png",
    scale: 2,
    anchor: 0.5,
  });
  gsap.to(buyBonusPopup.burst, {
    duration: 3,
    rotation: Math.PI * 2,
    repeat: -1,
    ease: "none",
  });

  buyBonusPopup.chestAwardSprites = {
    6: resourceManager.createObject("sprite", "6FreeSpins", "chestAnimationContainer", {
      fileName: "Chests/6FreeSpins.png",
      anchor: 0.5,
      scaleX: 1.5,
      scaleY: 1.5,
    }),
    8: resourceManager.createObject("sprite", "8FreeSpins", "chestAnimationContainer", {
      fileName: "Chests/8FreeSpins.png",
      anchor: 0.5,
      scaleX: 1.5,
      scaleY: 1.5,
    }),
    10: resourceManager.createObject("sprite", "10FreeSpins", "chestAnimationContainer", {
      fileName: "Chests/10FreeSpins.png",
      anchor: 0.5,
      scaleX: 1.5,
      scaleY: 1.5,
    }),
    12: resourceManager.createObject("sprite", "12FreeSpins", "chestAnimationContainer", {
      fileName: "Chests/12FreeSpins.png",
      anchor: 0.5,
      scaleX: 1.5,
      scaleY: 1.5,
    }),
    16: resourceManager.createObject("sprite", "16FreeSpins", "chestAnimationContainer", {
      fileName: "Chests/16FreeSpins.png",
      anchor: 0.5,
      scaleX: 1.5,
      scaleY: 1.5,
    }),
    20: resourceManager.createObject("sprite", "20FreeSpins", "chestAnimationContainer", {
      fileName: "Chests/20FreeSpins.png",
      anchor: 0.5,
      scaleX: 1.5,
      scaleY: 1.5,
    }),
    24: resourceManager.createObject("sprite", "24FreeSpins", "chestAnimationContainer", {
      fileName: "Chests/24FreeSpins.png",
      anchor: 0.5,
      scaleX: 1.5,
      scaleY: 1.5,
    }),
  };

  Object.values(buyBonusPopup.chestAwardSprites).forEach((sprite) => {
    sprite.visible = false;
  });
  buyBonusPopup.chestAnimations.silver.gotoAndStop(0);
  buyBonusPopup.chestAnimations.mystery.gotoAndStop(0);
  buyBonusPopup.chestAnimations.gold.gotoAndStop(0);
  buyBonusPopup.chestAnimations.silver.visible = false;
  buyBonusPopup.chestAnimations.mystery.visible = false;
  buyBonusPopup.chestAnimations.gold.visible = false;

  buyBonusPopup.clickToContinue = resourceManager.get("continueContainer");
  gsap.to(buyBonusPopup.clickToContinue, {
    duration: 0.8,
    pixi: { scaleX: 0.92, scaleY: 0.92 },
    yoyo: true,
    repeat: -1,
    ease: "power1.inOut",
  });

  buyBonusPopup.clickToContinue.visible = false;

  buyBonusPopup.burst.visible = false;
};

buyBonusPopup.show = function (callback) {
  buyBonusPopup.background.alpha = 1;

  buyBonusPopup.open = true;
  gameController.justEnteredBuyABonus = true;

  buyBonusPopup.closeButton.enableButton(true);

  messageBus.post("game:modal", {
    reason: "buy_bonus",
    data: "buy_bonus_show",
  });

  const highFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_HIGH.coinSizes;
  const medFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_MED.coinSizes;
  const lowFreeSpinsStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW.coinSizes;

  buyBonusPopup.allStakesCombined = lowFreeSpinsStakes.concat(
    medFreeSpinStakes.filter(function (el) {
      medFreeSpinStakes.indexOf(el) === -1;
    }),
    highFreeSpinStakes.filter(function (el) {
      highFreeSpinStakes.indexOf(el) === -1;
    })
  );

  buyBonusPopup.allStakesCombined.sort(function (a, b, c) {
    return a - b - c;
  });

  const MedFreeSpinsDefault = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_MED.defaultAmountPerLine;
  const fsDefault = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW.defaultAmountPerLine;

  let defaultToUse = MedFreeSpinsDefault;

  if (MedFreeSpinsDefault !== fsDefault) {
    defaultToUse = Math.min(MedFreeSpinsDefault, fsDefault);
  }

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;
  const crtBaseStake = gameController.globalHelperGetBaseStake();
  const stakeController = resourceManager.getController("stakeController");
  const numLines = stakeController.CurrentWinLineCount;

  const index = bonusBuyStakes.findIndex((stake) => stake * numLines === crtBaseStake);

  if (index !== -1) {
    buyBonusPopup.combinedStakeIndex = index;
  } else {
    buyBonusPopup.combinedStakeIndex = bonusBuyStakes.length - 1;
  }

  buyBonusPopup.updatePopup();

  resourceManager.getContainer("buyABonusContainer").visible = true;
  buyBonusPopup.container.visible = true;
  buyBonusPopup.callback = callback;
};

buyBonusPopup.updatePopup = function () {
  if (buyBonusPopup.stakeIndex === -1) {
    buyBonusPopup.stakePreviousButton.enableButton(false);
    buyBonusPopup.stakeNextButton.enableButton(false);

    buyBonusPopup.higherFreeSpinsButton.enableButton(false);
    buyBonusPopup.middleFreeSpinsButton.enableButton(false);
    buyBonusPopup.lowerFreeSpinsButton.enableButton(false);
  } else {
    const bonusBuyStakes = buyBonusPopup.allStakesCombined;

    buyBonusPopup.stakePreviousButton.enableButton(buyBonusPopup.combinedStakeIndex > 0);
    buyBonusPopup.stakeNextButton.enableButton(buyBonusPopup.combinedStakeIndex < bonusBuyStakes.length - 1);

    let baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.combinedStakeIndex]);
    buyBonusPopup.baseStakeText.setText(gdk.formatCurrency(baseStake));

    const highFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_HIGH.coinSizes;
    const medFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_MED.coinSizes;
    const lowFreeSpinsStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW.coinSizes;

    const stakeToFind = bonusBuyStakes[buyBonusPopup.combinedStakeIndex];

    let highFreespinsStakeExists = highFreeSpinStakes.includes(stakeToFind);
    let medFreespinsStakeExists = medFreeSpinStakes.includes(stakeToFind);
    let lowSpinsStakeExists = lowFreeSpinsStakes.includes(stakeToFind);

    const costHighFreespins = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsHigh;
    buyBonusPopup.higherFreeSpinsCostText.setText(gdk.formatCurrency(costHighFreespins));
    const highEnabled = buyBonusPopup.balance >= costHighFreespins && highFreespinsStakeExists;
    buyBonusPopup.toggleButtonEnable(buyBonusPopup.high, highEnabled);

    const costMedFreespins = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsMed;
    buyBonusPopup.middleFreeSpinsCostText.setText(gdk.formatCurrency(costMedFreespins));
    const midEnabled = buyBonusPopup.balance >= costMedFreespins && medFreespinsStakeExists;
    buyBonusPopup.toggleButtonEnable(buyBonusPopup.mid, midEnabled);

    const costlowFreespins = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsLow;
    buyBonusPopup.lowerFreeSpinsCostText.setText(gdk.formatCurrency(costlowFreespins));
    const lowerEnabled = buyBonusPopup.balance >= costlowFreespins && lowSpinsStakeExists;
    buyBonusPopup.toggleButtonEnable(buyBonusPopup.low, lowerEnabled);
  }
};

buyBonusPopup.toggleButtonEnable = function (obj, enabled) {
  obj.button.enableButton(enabled);
  obj.text.tint = enabled ? 0xffffff : 0x999999;
  obj.container.alpha = enabled ? 1 : 0.6;
};

buyBonusPopup.create = function (json) {
  return new PIXI.Container();
};

buyBonusPopup.convertToTotalStake = function (coinSize) {
  const stakeController = resourceManager.getController("stakeController");
  const numLines = stakeController.CurrentWinLineCount;

  return coinSize * numLines;
};

buyBonusPopup.onStakeNextPressed = function () {
  soundManager.play("buttonPressed");

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;
  buyBonusPopup.combinedStakeIndex = Math.min(buyBonusPopup.combinedStakeIndex + 1, bonusBuyStakes.length - 1);
  buyBonusPopup.updatePopup();
};

buyBonusPopup.onStakePreviousPressed = function () {
  soundManager.play("buttonPressed");

  buyBonusPopup.combinedStakeIndex = Math.max(buyBonusPopup.combinedStakeIndex - 1, 0);
  buyBonusPopup.updatePopup();
};

buyBonusPopup.initialise = function (json, container) {
  buyBonusPopup.container = container;
  buyBonusPopup.container.visible = false;

  buyBonusPopup.fadedMask = new PIXI.Graphics();
  buyBonusPopup.fadedMask.beginFill(0, 0.8);
  buyBonusPopup.fadedMask.drawRect(-10000, -10000, 20000, 20000);
  buyBonusPopup.fadedMask.endFill();
  buyBonusPopup.container.addChild(buyBonusPopup.fadedMask);
  messageBus.subscribe("spinner:GameConfigEvent", buyBonusPopup.onGameConfig);
  messageBus.subscribe("common:BalanceEvent", buyBonusPopup.onBalanceEvent);
  messageBus.subscribe("game:modal", buyBonusPopup.onModal);
  Reflex.registerEventHandler("layoutChange", buyBonusPopup.onLayoutChange);

  buyBonusPopup.helpActive = false;
};

buyBonusPopup.onLayoutChange = function () {
  if (buyBonusPopup.chosenChest != undefined) {
    if (buyBonusPopup.raiseChestAnim) {
      buyBonusPopup.raiseChestAnim.progress(1);
    }

    const posY = systemData.isLandscape
      ? buyBonusPopup.chosenChestTarget.landscape
      : buyBonusPopup.chosenChestTarget.portrait;

    buyBonusPopup.chestAnimationContainer.y = posY;
  }
  if (!buyBonusPopup.textLow) return;

  buyBonusPopup.textLow.setText("6-12 " + buyBonusPopup.textLow.text);
  buyBonusPopup.textMid.setText("6-24 " + buyBonusPopup.textMid.text);
  buyBonusPopup.textHigh.setText("12-24 " + buyBonusPopup.textHigh.text);
};

buyBonusPopup.onModal = function (data) {
  if (buyBonusPopup.container.visible) {
    if (data.reason && data.reason === "Options menu open") {
      buyBonusPopup.helpActive = true;

      buyBonusPopup.freeSpinsButton.enableButton(false);
      buyBonusPopup.closeButton.enableButton(false);

      buyBonusPopup.stakePreviousButton.enableButton(false);
      buyBonusPopup.stakeNextButton.enableButton(false);
    } else if (buyBonusPopup.helpActive) {
      buyBonusPopup.helpActive = false;

      buyBonusPopup.freeSpinsButton.enableButton(true);
      buyBonusPopup.closeButton.enableButton(true);

      buyBonusPopup.updatePopup();
    }

    if (buyBonusPopup.open) {
      if (data.reason === undefined) {
        messageBus.post("game:modal", {
          reason: "buy_bonus",
          data: "buy_bonus_show (onModal)",
        });
      }
    }
  }
};

buyBonusPopup.onGameConfig = function (event) {
  buyBonusPopup.gameConfig = event;
  buyBonusPopup.init();
};

buyBonusPopup.onBalanceEvent = function (event) {
  buyBonusPopup.balance = event.data.balance;
};

buyBonusPopup.onClosePopup = function (buyBonus) {
  buyBonusPopup.open = false;
  gameController.justEnteredBuyABonus = false;

  if (buyBonus) {
    musicManager.onFreeSpinsStart();

    buyBonusPopup.clearBubbles();
    musicManager.stopBubbles();
  } else {
    soundManager.play("buyBonusClick");
    buyBonusPopup.container.visible = false;

    let reels = resourceManager.get("slotContainer:reelContainer");
    reels.alpha = 1.0;

    if (buyBonusPopup._callback) {
      buyBonusPopup._callback();
      buyBonusPopup._callback = undefined;
      buyBonusPopup.reset();
    }
    buyBonusPopup.callback(buyBonus);
  }
};

buyBonusPopup.clearBubbles = function () {
  buyBonusPopup.bubblesBack.stopBubbles();
  buyBonusPopup.bubblesFront.stopBubbles();

  Object.values(buyBonusPopup.chestAwardSprites).forEach((sprite) => {
    sprite.visible = false;
  });
  buyBonusPopup.burst.visible = false;
  buyBonusPopup.clickToContinue.visible = false;

  buyBonusPopup.chosenChest.onComplete = () => {};
  buyBonusPopup.chosenChest.animationSpeed = -1;
  buyBonusPopup.chosenChest.gotoAndPlay(buyBonusPopup.chosenChest.totalFrames - 1);

  const duration = 1;
  let reels = resourceManager.get("slotContainer:reelContainer");

  gsap.to(reels, { duration, alpha: 1 });

  gsap.to(buyBonusPopup.fadedMask, { duration, alpha: 0 });

  gsap.to(buyBonusPopup.chestAnimationContainer, {
    y: -400,
    duration,
    ease: "back.in(1)",
    onComplete: () => {
      if (buyBonusPopup._callback) {
        buyBonusPopup._callback();
        buyBonusPopup._callback = undefined;
        buyBonusPopup.reset();
      }
      buyBonusPopup.callback(true);
    },
  });
};

buyBonusPopup.onStartBonusSpin = function () {
  const sp = gdk.getServerParser();
  const isReplay = sp.isReplayMode !== undefined ? sp.isReplayMode() : false;

  gameController.boughtBonus = true;

  if (isReplay) return;

  gameController.justEnteredBuyABonus = false;
  gameController.inBuyABonus = true;

  gameData.winningsMeter.set(0);
  gameController.totalWinnings = 0;

  messageBus.post("game:modal", { data: "buy_bonus_start" });

  let stakeController = resourceManager.getController("stakeController");
  const numLines = stakeController.CurrentWinLineCount;

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;

  let baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.combinedStakeIndex]);
  let stakes = stakeController.Stakes;
  let returnStake = stakes.find((stake) => stake === baseStake);

  if (!returnStake) {
    returnStake = stakes[0];
  }

  stakeController.requestChangeStake(returnStake);

  let bonusType;
  let buyCost;

  gameController.buyBonusLow = false;
  gameController.buyBonusMed = false;
  gameController.buyBonusHigh = false;

  if (buyBonusPopup.buyBonusHigh) {
    bonusType = "BONUS_BUY_HIGH";
    buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsHigh;
    gameController.buyBonusHigh = true;
  } else if (buyBonusPopup.buyBonusMed) {
    bonusType = "BONUS_BUY_MED";
    buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsMed;
    gameController.buyBonusMed = true;
  } else {
    bonusType = "BONUS_BUY_LOW";
    buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsLow;
    gameController.buyBonusLow = true;
  }

  gameController.buyBonusStake = baseStake * buyCost;

  stakeController.requestChangeStake(baseStake, bonusType);

  const bpl = baseStake / numLines;

  resourceManager.get("potMetersContainer").updateMeterValues();
  gameController.stopCyclingWins();

  gdk.startGame(
    {
      stake: baseStake * buyCost,
      numWinlines: numLines,
      bpl: bpl,
      metaData: {
        encore: false,
        buyABonus: true,
        buyBonusLowActive: buyBonusPopup.buyBonusLow,
        buyBonusMedActive: buyBonusPopup.buyBonusMed,
        buyBonusHighActive: buyBonusPopup.buyBonusHigh,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

buyBonusPopup.playBubblesAnimation = async (cb) => {
  buyBonusPopup.higherFreeSpinsButton.enableButton(false);
  buyBonusPopup.middleFreeSpinsButton.enableButton(false);
  buyBonusPopup.lowerFreeSpinsButton.enableButton(false);
  buyBonusPopup.stakePreviousButton.enableButton(false);
  buyBonusPopup.stakeNextButton.enableButton(false);
  buyBonusPopup.closeButton.enableButton(false);

  gsap.to(buyBonusPopup.background, {
    duration: 0.3,
    delay: 0.5,
    alpha: 0,
  });

  gameController.inFreeSpins = true;
  buyBonusPopup.bubblesFront.startBubbles();
  buyBonusPopup.bubblesBack.startBubbles();
  musicManager.startBubbles();

  await buyBonusPopup.delay(700);

  musicManager.onFreeSpinsIntro();
  buyBonusPopup.bubblesFront.stopBubbles();

  await buyBonusPopup.delay(300);

  await buyBonusPopup.raiseChosenChest();

  soundManager.play("chestShake");
  buyBonusPopup.shakeChosenChest();

  await buyBonusPopup.delay(100);

  await cb();
};

buyBonusPopup.delay = (ms) => new Promise((res) => setTimeout(res, ms));

buyBonusPopup.raiseChosenChest = () => {
  buyBonusPopup.chosenChest.visible = true;
  buyBonusPopup.chestAnimationContainer.visible = true;
  buyBonusPopup.chestAnimationContainer.y = systemData.isLandscape ? 800 : 1360;
  buyBonusPopup.chestAnimationContainer.rotation = 0.5;

  const targetY = systemData.isLandscape
    ? buyBonusPopup.chosenChestTarget.landscape
    : buyBonusPopup.chosenChestTarget.portrait;

  return new Promise((resolve) => {
    buyBonusPopup.raiseChestAnim = gsap.to(buyBonusPopup.chestAnimationContainer, {
      y: targetY,
      duration: 2.8,
      rotation: 0,
      ease: "elastic.out(1, 0.5)",
      onComplete: () => {
        buyBonusPopup.raiseChestAnim = undefined;
        resolve();
      },
    });
  });
};

buyBonusPopup.shakeChosenChest = () => {
  const tweenConfig = {
    firstRotate: { rotation: 0.15, duration: 0.15, ease: "power1.inOut" },
    centre: { rotation: 0, duration: 1.2, ease: "elastic.out(1, 0.3)" },
  };

  return new Promise((resolve) => {
    gsap
      .timeline()
      .to(buyBonusPopup.chosenChest, tweenConfig.firstRotate)
      .to(buyBonusPopup.chosenChest, tweenConfig.centre)
      .call(() => {
        resolve();
      });
  });
};

buyBonusPopup.onClickedYesLower = async () => {
  soundManager.play("buyBonusClick");

  buyBonusPopup.buyBonusHigh = false;
  buyBonusPopup.buyBonusMed = false;
  buyBonusPopup.buyBonusLow = true;
  buyBonusPopup.closeButton.enableButton(false);
  buyBonusPopup.chosenChest = buyBonusPopup.chestAnimations.silver;

  buyBonusPopup.playBubblesAnimation(async () => {
    buyBonusPopup.onStartBonusSpin();
  });
};

buyBonusPopup.onClickedYesMed = async () => {
  soundManager.play("buyBonusClick");

  buyBonusPopup.buyBonusHigh = false;
  buyBonusPopup.buyBonusMed = true;
  buyBonusPopup.buyBonusLow = false;
  buyBonusPopup.closeButton.enableButton(false);

  buyBonusPopup.chosenChest = buyBonusPopup.chestAnimations.mystery;

  buyBonusPopup.playBubblesAnimation(async () => {
    buyBonusPopup.onStartBonusSpin();
  });
};

buyBonusPopup.onClickedYesHigh = async () => {
  soundManager.play("buyBonusClick");

  buyBonusPopup.buyBonusHigh = true;
  buyBonusPopup.buyBonusMed = false;
  buyBonusPopup.buyBonusLow = false;
  buyBonusPopup.closeButton.enableButton(false);
  buyBonusPopup.chosenChest = buyBonusPopup.chestAnimations.gold;

  buyBonusPopup.playBubblesAnimation(async () => {
    buyBonusPopup.onStartBonusSpin();
  });
};

buyBonusPopup.openChest = async (level, numFS, callback, openChestCb) => {
  const sp = gdk.getServerParser();
  const isReplay = sp.isReplayMode !== undefined ? sp.isReplayMode() : false;
  if (isReplay) {
    buyBonusPopup.show(() => {});
    if (gameController.buyBonusType === "BONUS_BUY_LOW") {
      await buyBonusPopup.onClickedYesLower();
    } else if (gameController.buyBonusType === "BONUS_BUY_MED") {
      await buyBonusPopup.onClickedYesMed();
    } else {
      await buyBonusPopup.onClickedYesHigh();
    }

    await buyBonusPopup.delay(5000);
  }

  buyBonusPopup.chosenChest = level === 0 ? buyBonusPopup.chestAnimations.silver : buyBonusPopup.chestAnimations.gold;
  buyBonusPopup.chosenChest.visible = true;
  buyBonusPopup.chestAnimations.mystery.visible = false;

  buyBonusPopup._callback = callback;
  buyBonusPopup.chosenChest.gotoAndPlay(0);
  buyBonusPopup.chosenChest.onComplete = () => {
    if (openChestCb) {
      openChestCb();
    }

    buyBonusPopup.burst.visible = true;
    buyBonusPopup.chestAwardSprites[numFS].visible = true;
    gsap
      .timeline()
      .fromTo(buyBonusPopup.burst.scale, { x: 0.25, y: 0.25 }, { duration: 0.1, x: 2, y: 2 })
      .fromTo(buyBonusPopup.burst, { alpha: 0 }, { alpha: 1, duration: 0.1 }, "<");
    buyBonusPopup.setActive();
  };

  buyBonusPopup.clickToContinue.visible = true;

  soundManager.play("buyBonus");
  soundManager.play("chestOpen");

  if (level === 1) {
    buyBonusPopup.showBonusChest(true, 1);
  } else {
    buyBonusPopup.showBonusChest(true, 0);
  }

  musicManager.playDevilLaughSound();
};

buyBonusPopup.setActive = () => {
  buyBonusPopup.continueBox.visible = true;
  buyBonusPopup.continueBox.interactive = true;
  buyBonusPopup.continueBox.mousedown = buyBonusPopup.continueBox.touchstart = buyBonusPopup.onClosePopup.bind(
    this,
    true
  );
};

buyBonusPopup.showBonusChest = (show, level) => {
  const chests = resourceManager.get("chestsContainer");
  chests._showBonusChest(show, level);
};

buyBonusPopup.onClickedNo = function () {
  buyBonusPopup.open = false;

  messageBus.post("game:modal", { data: "buy_bonus_cancel" });

  buyBonusPopup.onClosePopup(false);
};

buyBonusPopup.reset = () => {
  Object.values(buyBonusPopup.chestAwardSprites).forEach((sprite) => {
    sprite.visible = false;
  });

  buyBonusPopup.chestAnimationContainer.visible = false;
  buyBonusPopup.container.visible = false;
  buyBonusPopup.fadedMask.alpha = 1;

  buyBonusPopup.chosenChest.animationSpeed = 1;

  buyBonusPopup.burst.visible = false;
  buyBonusPopup.clickToContinue.visible = false;

  buyBonusPopup.chestAnimations.silver.gotoAndStop(0);
  buyBonusPopup.chestAnimations.mystery.gotoAndStop(0);
  buyBonusPopup.chestAnimations.gold.gotoAndStop(0);
  buyBonusPopup.chestAnimations.silver.visible = false;
  buyBonusPopup.chestAnimations.mystery.visible = false;
  buyBonusPopup.chestAnimations.gold.visible = false;
  buyBonusPopup.continueBox.visible = false;
  buyBonusPopup.continueBox.interactive = false;
  buyBonusPopup.continueBox.mousedown = buyBonusPopup.continueBox.touchstart = undefined;
};

buyBonusPopup.getFilesRequired = function (json) {
  return [];
};

resourceManager.registerObjectType(
  "buyBonusPopup",
  buyBonusPopup.create,
  buyBonusPopup.initialise,
  buyBonusPopup.getFilesRequired
);
